
export const COMMON_KEY = '_';

// TODO: 추후 해당 필드 참조 부분 제거하고  @/api/managetype-key의 getDisplayedManagetypeKeyList에서 받은 응답 값으로 처리 필요
export const NMS = [
  {
    label: '장비',
    managetypeKey: 'ND',
  },
  {
    label: '인터페이스',
    managetypeKey: 'NI',
  },
];

export const FMS = [
  {
    label: '장비',
    managetypeKey: 'FD',
  },
  {
    label: '센서',
    managetypeKey: 'FS',
  },
];

export const DBMS = [
  {
    label: '공통',
    managetypeKey: '_',
  },
  {
    label: 'Oracle',
    managetypeKey: 'OR',
  },
  {
    label: 'MS-SQL',
    managetypeKey: 'MS',
  },
  {
    label: 'Informix',
    managetypeKey: 'IN',
  },
  {
    label: 'Sybase',
    managetypeKey: 'SY',
  },
  {
    label: 'MySql',
    managetypeKey: 'MY',
  },
  {
    label: 'Tibero',
    managetypeKey: 'TB',
  },
  {
    label: 'SybaseIQ',
    managetypeKey: 'IQ',
  },
  {
    label: 'Altibase',
    managetypeKey: 'AT',
  },
  {
    label: 'DB2',
    managetypeKey: 'DB2',
  },
  {
    label: 'PostgreSQL',
    managetypeKey: 'PG',
  },
  {
    label: 'Cubrid',
    managetypeKey: 'CU',
  },
];

export const VMS = [
  {
    label: '호스트 클러스터',
    managetypeKey: 'VCL',
  },
  {
    label: '호스트',
    managetypeKey: 'VHO',
  },
  {
    label: 'VM',
    managetypeKey: 'VVM',
  },
  {
    label: '스토리지 클러스터',
    managetypeKey: 'VDSC',
  },
  {
    label: '스토리지',
    managetypeKey: 'VDS',
  },

];

export const MANAGETYPE_KEY = { NMS, FMS, DBMS, VMS };



// WEBPACK FOOTER //
// ./src/constants/managetype-key.js